import React from "react";

const GizlilikCerezTablo = () => (
  <div>
    {/* Tarayıcıya göre çerez yönetimi tablosu */}
    <div className="overflow-x-auto my-4">
      <div className="p-2 text-sm text-grayy font-normal">İnternet tarayıcıları genellikle çerezleri otomatik olarak kaydedecek şekilde kullanımınıza sunulur. Bu sebeple çerezler, kullandığınız internet tarayıcısı tarafından otomatik kabul edilebilir. Çerezlerin kaydedilmesini istemediğiniz ya da silmek istediğiniz takdirde kullandığınız tarayıcının ayarlarından bu tercihinizi size sunulan diğer tercihlerle değiştirebilirsiniz. Çerezler, internet sitemizdeki kişisel tercihlerinizin hatırlanmasını sağlayarak Juniors'tan en iyi şekilde faydalanmanızı sağlar. Çerezleri engellediğinizde, sildiğinizde veya çerez yerleştirme tercihinizi değiştirdiğinizde internet sitemizi ya da bazı özellikleri kullanamayabilirsiniz. Çerezler size ait bir veri olup internet sitemize kullanıcı girişi yapılmadığında tarayıcınız tarafından anonim olarak işlenebilir. Çerezler tarayıcınız tarafından tutulduğundan www.juniorscenter.com  internet sitesinin kaydedilen çerezleri yönetme, değiştirme ya da silme yetkisi bulunmamaktadır. Bu sebeple çerezler bakımından www.juniorscenter.com internet sitesi veri sorumlusu sıfatına sahip değildir.<br></br>
      Aşağıdaki yöntemleri kullanarak çerezlere izin verme ve reddetme imkanını kullanabilirsiniz:</div>
      <br></br>
      <table className="min-w-full border text-xs">
        <thead>
          <tr>
            <th className="border px-2 py-3 text-grayy">Tarayıcı</th>
            <th className="border px-2 py-3 text-grayy">Açıklama</th>
          </tr>
        </thead>
        <tbody>
          <tr>
            <td className="border px-2 py-3 text-grayy">Google Chrome</td>
            <td className="border px-2 py-3 text-grayy">
              Tarayıcınızın adres bölümünde yer alan, "kilit işareti"ni
              tıklayarak, "çerezler" sekmesinden çerezlere izin verebilir veya
              engelleyebilirsiniz.
            </td>
          </tr>
          <tr>
            <td className="border px-2 py-3 text-grayy">Internet Explorer</td>
            <td className="border px-2 py-3 text-grayy">
              Tarayıcınızın sağ üst bölümünde yer alan "Araçlar" bölümünden
              güvenlik sekmesini tıklayarak "izin ver" veya "izin verme"
              şeklinde çerezleri yönetebilirsiniz.
            </td>
          </tr>
          <tr>
            <td className="border px-2 py-3 text-grayy">Mozilla Firefox</td>
            <td className="border px-2 py-3 text-grayy">
              Tarayıcınızın sağ üst köşesinde yer alan "menüyü aç" sekmesini
              tıklayınız. "Seçenekler" görselini tıklayarak "Gizlilik ve
              Güvenlik" butonunu kullanarak çerezleri yönetebilirsiniz.
            </td>
          </tr>
          <tr>
            <td className="border px-2 py-3 text-grayy">Opera</td>
            <td className="border px-2 py-3 text-grayy">
              Tarayıcınızın "Tercihler" bölümünde "Gelişmiş"i seçerek "çerezler"
              bölümünden çerez yönetimini yapabilirsiniz.
            </td>
          </tr>
          <tr>
            <td className="border px-2 py-3 text-grayy">Safari</td>
            <td className="border px-2 py-3 text-grayy">
              Telefonunuzun "Ayarlar" bölümünden "safari" sekmesini seçip,
              "Gizlilik ve Güvenlik" bölümünden tüm çerez yönetiminizi
              yapabilirsiniz.
            </td>
          </tr>
        </tbody>
      </table>
      <br></br>
    </div>
    {/* Açıklama yazısı */}
    <div className="p-2 text-sm text-grayy font-normal">
    Yukarıdaki seçeneklerin yanı sıra; tüm çerezler hakkında bilgi sahibi olmak ve çerez yönetimi için: https://www.allaboutcookies.org, https://www.youronlinechoices.eu/ adresini ziyaret edebilirsiniz, veya "Privacy Badger" uygulamasını kullanabilirsiniz (https://www.eff.org/tr/privacybadger). Kalıcı çerezleri veya oturum çerezlerini reddederseniz, web sitesini, mobil uygulamayı ve mobil sitesini kullanmaya devam edebilirsiniz fakat web sitesinin, mobil uygulamanın ve mobil sitesinin tüm işlevlerine erişemeyebilirsiniz veya erişiminiz sınırlı olabilir.
      <br />
      <br />
      <span className="font-semibold">
        JUNIORS'ta yer alan çerezlere ilişkin bilgiler aşağıdaki tablolarda yer
        almaktadır:
      </span>
    </div>
    {/* Çerez detay tablosu */}
    <div className="overflow-x-auto my-4">
      <br></br>
      <table className="min-w-full border text-xs">
        <thead>
          <tr>
            <th className="border px-2 py-1 text-grayy">Sağlayıcı</th>
            <th className="border px-2 py-1 text-grayy">Çerez</th>
            <th className="border px-2 py-1 text-grayy">Açıklama</th>
            <th className="border px-2 py-1 text-grayy">Tür</th>
            <th className="border px-2 py-1 text-grayy">Saklama Süresi</th>
          </tr>
        </thead>
        <tbody>
          <tr>
            <td className="border px-2 py-2 text-grayy">Google</td>
            <td className="border px-2 py-2 text-grayy">_ga</td>
            <td className="border px-2 py-2 text-grayy">
              Analytics cihaz bilgisi - Google Tag Manager sisteminde yer alan
              uygulamaların kullanılması için
            </td>
            <td className="border px-2 py-2 text-grayy">Persistent Cookie</td>
            <td className="border px-2 py-2 text-grayy">2 Yıl</td>
          </tr>
          <tr>
            <td className="border px-2 py-2 text-grayy">Google</td>
            <td className="border px-2 py-2 text-grayy">_gat, _gta</td>
            <td className="border px-2 py-2 text-grayy">
              Web Sitesinin yoğun ziyaret edildiği zamanlarda kullanıcının talep
              oranının kısıtlanması için
            </td>
            <td className="border px-2 py-2 text-grayy">Persistent</td>
            <td className="border px-2 py-2 text-grayy">1 Dk</td>
          </tr>
          <tr>
            <td className="border px-2 py-2 text-grayy">Google</td>
            <td className="border px-2 py-2 text-grayy">_gid</td>
            <td className="border px-2 py-2 text-grayy">
              Kullanıcı tanımlama için
            </td>
            <td className="border px-2 py-2 text-grayy">Persistent</td>
            <td className="border px-2 py-2 text-grayy">1 Gün</td>
          </tr>
          <tr>
            <td className="border px-2 py-2 text-grayy">Cloudflare</td>
            <td className="border px-2 py-2 text-grayy">_cfduid</td>
            <td className="border px-2 py-2 text-grayy">
              Güvenilir web trafiğini tanımlamak için CloudFlare hizmeti
              tarafından belirlenir. Web uygulamasındaki herhangi bir kullanıcı
              kimliğine karşılık gelmez, çerez de kişisel olarak tanımlanabilir
              bilgileri depolamaz.
            </td>
            <td className="border px-2 py-2 text-grayy">Persistent</td>
            <td className="border px-2 py-2 text-grayy">30 Gün</td>
          </tr>
          <tr>
            <td className="border px-2 py-2 text-grayy">Facebook</td>
            <td className="border px-2 py-2 text-grayy">_fbp</td>
            <td className="border px-2 py-2 text-grayy">
              Facebook tarafından, üçüncü taraf reklam verenlerin gerçek zamanlı
              teklifleri gibi çeşitli reklam ürünlerini görüntülemek için
              kullanılır.
            </td>
            <td className="border px-2 py-2 text-grayy">Persistent</td>
            <td className="border px-2 py-2 text-grayy">6 Ay</td>
          </tr>
        </tbody>
      </table>
      <br></br>
    </div>
  </div>
);

export default GizlilikCerezTablo;
